import { Formatter } from "./Formatter";
import type { FilterNode } from "./nodes";

/**
 * Base visitor function that traverses the AST.
 */
export function format(node: FilterNode, formatter: Formatter): string {
  switch (node.type) {
    case "predicate":
      return formatter.formatPredicate(node);
    case "range":
      return formatter.formatRange(node);
    case "and":
      return formatter.formatAnd(node, (n) => format(n, formatter));
    case "or":
      return formatter.formatOr(node, (n) => format(n, formatter));
    case "not":
      return formatter.formatNot(node, (n) => format(n, formatter));
    default:
      //use compiler to ensure this is unreachable for defined node types
      const exhaustive: never = node;
      throw new Error(`Unknown node type: ${(exhaustive as any).type}`);
  }
}
